import { http } from 'config';

import { TASK_STATUS_BY_ID_URL } from './endpoints';

interface TaskStatus {
  task_id: string;
  task_status: 'PENDING' | 'SUCCESS' | 'FAILURE';
  task_result: string;
}

export const getTaskStatus = async (taskId: string) =>
  await http.get<TaskStatus>(TASK_STATUS_BY_ID_URL(taskId));
